import { AppBBWaardecheckReportPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../../../constants';

export default (): AppBBWaardecheckReportPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.EVENT_CONTACT_APP_BBWAARDECHECK_REPORT_POINTER,
  variable: null,
});
